import { combineReducers } from "redux";
import { reportsCenterReducer } from "./reportsCenterReducer";
import ui from "./ui";
import { generateReportReducer } from "./generateReportReducer";
var rootReducer = combineReducers({
    reportsCenter: reportsCenterReducer,
    generateReport: generateReportReducer,
    ui: ui
});
export default rootReducer;

//# sourceMappingURL=index.js.map